import React, { useEffect, useState, useRef } from "react";
import { Chip, Modal, Box, Typography, Divider, Grid, Avatar, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import soundFile from "../../Raw/stopped.mp3";

const Movement = ({ user, isTripActive = true }) => {
  const [open, setOpen] = useState(false);
  const [countdown, setCountdown] = useState(180);
  const [stillStoppedCounter, setStillStoppedCounter] = useState(0);
  const audio = useRef(new Audio(soundFile));
  const countdownRef = useRef(null);
  const rawMovingVal = user?.is_moving ?? user?.IsMoving ?? user?.isMoving ?? user?.tripData?.is_moving ?? user?.tripData?.IsMoving;
  const activeSpeed = Number(
    user?.LiveSpeed ?? user?.CurrentSpeed ?? user?.currentSpeed ?? user?.speed ?? user?.Speed ??
    user?.tripData?.LiveSpeed ?? user?.tripData?.CurrentSpeed ?? user?.tripData?.speed ??
    user?.calculatedGpsSpeed ?? 0
  );

  let isMoving = false;
  if (rawMovingVal !== undefined && rawMovingVal !== null) {
    isMoving = rawMovingVal === true || String(rawMovingVal).toLowerCase() === "true" || rawMovingVal === 1 || rawMovingVal === "1";
  }

  // Consistent with Escort dashboard: if telemetry or GPS speed > 0, the user is in motion
  if (activeSpeed > 0) {
    isMoving = true;
  }

  const status = isTripActive !== false && isMoving;

  const getColor = () => {
    if (isTripActive === false) {
      return { color: "#64748b", text: "Stopped" };
    }
    return status
      ? { color: "#0d47a1", text: activeSpeed > 0 ? `In Motion (${activeSpeed} km/h)` : "In Motion" }
      : { color: "#d50000", text: "Stopped" };
  };

  const color = getColor();

  // const formatTime = (sec) => {
  //   const m = String(Math.floor(sec / 60)).padStart(2, "0");
  //   const s = String(sec % 60).padStart(2, "0");
  //   return `${m}:${s}`;
  // };

  // useEffect(() => {
  //   let statusCheckInterval = null;

  //   if (!status) {
  //     statusCheckInterval = setInterval(() => {
  //       setStillStoppedCounter((prev) => prev + 1);
  //     }, 1000);
  //   } else {
  //     setStillStoppedCounter(0);
  //     setOpen(false);
  //     setCountdown(180);
  //     clearInterval(countdownRef.current);
  //     audio.current.pause();
  //     audio.current.currentTime = 0;
  //   }

  //   return () => clearInterval(statusCheckInterval);
  // }, [status]);

  // useEffect(() => {
  //   if (stillStoppedCounter === 120 && !open) {
  //     // setOpen(true);
  //     // audio.current.play();
  //     // audio.current.loop = false;
  //   }
  // }, [stillStoppedCounter, open]);

  // useEffect(() => {
  //   if (open) {
  //     countdownRef.current = setInterval(() => {
  //       setCountdown((prev) => {
  //         if (prev <= 1) {
  //           clearInterval(countdownRef.current);
  //           setOpen(false);
  //           return 0;
  //         }
  //         return prev - 1;
  //       });
  //     }, 1000);
  //   }

  //   return () => clearInterval(countdownRef.current);
  // }, [open]);

  return (
    <>
      <Chip
        label={<div style={{ textAlign: "center" }}>{color.text}</div>}
        style={{
          backgroundColor: color.color,
          color: "white",
          borderRadius: "5px",
          fontWeight: "bold",
          height: "auto",
          padding: "5px",
        }}
      />

      {/* <Modal
        open={open}
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            setOpen(false);
          }
        }}
        disableEscapeKeyDown
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            borderRadius: 3,
            p: 4,
            width: 400,
            maxWidth: "90%",
            position: "relative",
          }}
        >
          <IconButton
            onClick={() => setOpen(false)}
            sx={{ position: "absolute", top: 8, right: 8 }}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>

          <Typography variant="body1" color="error" gutterBottom>
            🚨 {user?.userName || "User"} is not Moving
          </Typography>

          <Box display="flex" justifyContent="center">
            <Typography variant="h1" color="primary" sx={{ mb: 1 }}>
              {formatTime(countdown)}
            </Typography>
          </Box>

          <Divider sx={{ mb: 0, bgcolor: "secondary.light" }} />

          <Typography variant="body1" sx={{ fontWeight: "bold", mb: 1 }}>
            User Info
          </Typography>
          <Grid container spacing={2} alignItems="center">
            <Grid item>
              <Avatar src={user?.userImage} alt={user?.userName} sx={{ width: 56, height: 56 }} />
            </Grid>
            <Grid item xs>
              <Typography variant="body2">
                <strong>Name:</strong> {user?.userName || "N/A"}
              </Typography>
              <Typography variant="body2">
                <strong>Mobile:</strong> {user?.userPhone || "N/A"}
              </Typography>
            </Grid>
          </Grid>

          <Divider sx={{ my: 1, bgcolor: "secondary.light" }} />

          <Typography variant="body2">
            <strong>Action Required:</strong>
            <br />
            Admin staff must immediately initiate a wellbeing check on the user:
            <ul>
              <li>Send a message via the chat platform.</li>
              <li>If no response in 2–3 minutes, proceed to the next step.</li>
              <li>Attempt to contact the user by phone.</li>
              <li>Confirm whether the phone is ringing or switched off.</li>
              <li>
                If the user cannot be reached, escalate immediately: Dispatch to VigilantEye to
                perform a physical check based on the user’s last known GPS location.
              </li>
            </ul>
          </Typography>
        </Box>
      </Modal> */}
    </>
  );
};

export default React.memo(Movement);
